import { action, observable } from 'mobx';
import stores from 'cd-eft/models/Stores';
import { removeSingleAlignmentLayer } from '../AlignmentSummaryTable/AlignmentSummaryTableVM';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

const alignmentStore = stores.AppStore.alignmentDesignStore;

export class AlignmentContainerVM {
  @observable unsavedCopiesDialogIsOpen: boolean = false;

  @action.bound closeUnsavedCopiesDialog() {
    this.unsavedCopiesDialogIsOpen = false;
  }

  // user leaving alignment section -->
  @observable notification: any = {
    openAlignment: '',
    unsavedCopies: '',
  };

  @action.bound async getErrors() {
    this.notification.openAlignment = await MessageCenter.addErrorLabelFromCode('Alignment_15'); // 'Please Save or Cancel Alignment Edits before leaving Alignment Design.';
    this.notification.unsavedCopies = await MessageCenter.addErrorLabelFromCode('Alignment_16'); // 'You have unsaved alignment copies.';
  }

  @action.bound userLeavingWarningOnOk() {
    if (alignmentStore.currentElement.name) {
      alignmentStore.currentTab = alignmentStore.currentElement.id ? 'Edit' : 'New';
    }
    return false;
  }

  @action.bound userLeavingWarningOnCancel() {
    // return true if you want proceed to the next page
    return true;
  }
  // <-- user leaving alignment section
}

export const removeAllUnsavedAlignments = () => {
  if (alignmentStore.unsavedAlignments.size > 0) {
    alignmentStore.unsavedAlignments.forEach((designElementId) => {
      removeSingleAlignmentLayer(`alignment${designElementId}`);
    });
  }
  alignmentStore.reset();
};
